<script>
import DibbleApi from '@/api';
import DibbleJS from '@/dibble';
import TextField from '@/commons/FormElements/TextField.vue';
import SelectField from '@/commons/FormElements/SelectField.vue';

export default {
    name: 'RegisterStep3',
    components: {
        TextField,
        SelectField,
    },
    data() {
        return {
            address1: '',
            address2: '',
            city: '',
            zip: '',
            state: '',
            country: '',
            previous_state: '',
            stateOutsideUS: [
                {
                    value: '',
                    label: 'Outside of the US',
                },
            ],
            states: [],
            countries: [],
        };
    },
    computed: {
        stateOptions() {
            return this.country === 'US' ? this.states : this.stateOutsideUS;
        },
        isDisabledStateOptions() {
            return this.country !== 'US';
        },
    },
    watch: {
        country(value) {
            if (value !== 'US') {
                this.previous_state = this.state;
                this.state = '';
            } else {
                this.state = this.previous_state;
            }
        },
    },
    methods: {
        onSubmit() {
            this.$emit('submit', {
                address1: this.address1,
                address2: this.address2,
                city: this.city,
                zip: this.zip,
                state: this.state,
                country: this.country,
            });
        },
        setData(value) {
            this.address1 = value.address1;
            this.address2 = value.address2;
            this.city = value.city;
            this.zip = value.zip;
            this.state = value.state;
            this.country = value.country;
        },
        getStates() {
            const params = {
                '#request': DibbleApi.api.getStateList,
            };
            DibbleJS.callApiRequest(params, (response) => {
                if (response.rc === 0) {
                    const { states } = response;
                    if (states.length) {
                        this.states = states.map((item) => ({
                            value: item.state_code,
                            label: item.name,
                        }));
                        this.state = states.find(
                            (state) => state.state_code === 'NY'
                        ).state_code;
                    }
                }
            });
        },
        getCountries() {
            const params = {
                '#request': DibbleApi.api.getCountryList,
            };
            DibbleJS.callApiRequest(params, (response) => {
                if (response.rc === 0) {
                    const { countries } = response;
                    if (countries.length) {
                        this.countries = countries.map((item) => ({
                            value: item.country_code,
                            label: item.name,
                        }));
                        this.country = countries.find(
                            (country) => country.country_code === 'US'
                        ).country_code;
                    }
                }
            });
        },
    },
    created() {
        this.getStates();
        this.getCountries();
    },
};
</script>

<template>
    <ValidationObserver v-slot="{ handleSubmit, invalid }">
        <form @submit.prevent="handleSubmit(onSubmit)">
            <TextField
                v-model="address1"
                name="address1"
                label="Address"
                rules="required"
            />
            <TextField
                v-model="address2"
                name="address2"
                label="Address 2"
            />
            <TextField
                v-model="city"
                name="city"
                label="City"
                rules="required"
            />
            <div class="row">
                <div class="col-7">
                    <SelectField
                        v-model="state"
                        name="state"
                        label="State"
                        :options="stateOptions"
                        :disabled="isDisabledStateOptions"
                    />
                </div>
                <div class="col-5">
                    <TextField
                        v-model="zip"
                        name="zip"
                        label="Zip Code"
                        rules="required"
                    />
                </div>
            </div>
            <SelectField
                v-model="country"
                name="country"
                label="Country"
                :options="countries"
                rules="required"
            />
            <button
                class="btn-dialog btn-sm ok-btn w-100 mt-5"
                type="submit"
                :disabled="invalid"
            >
                I'M DONE
            </button>
        </form>
    </ValidationObserver>
</template>
